import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {buildDerivativeUrl, toUploadsRelativePath} from '../../utils/image-url.util';

type ImgStrategy = 'resolve' | 'cache';

@Injectable({ providedIn: 'root' })
export class ImageUrlService {
  // Base API for images (/uploads and /media). Uses environment.apiUrl.
  private readonly apiBase = environment.apiUrl?.replace(/\/+$/, '') || '';

  // 'resolve' (routes Symfony) or 'cache' (pre-generated files).
  private readonly strategy: ImgStrategy = (environment.imgStrategy as ImgStrategy) || 'resolve';

  /** Return a derivative URL; fallback to original when not an uploads path. */
  derivative(filter: string, originalPublicUrl: string): string {
    const rel = toUploadsRelativePath(originalPublicUrl);
    if (!rel) return originalPublicUrl;
    return buildDerivativeUrl(this.apiBase, this.strategy, filter, rel);
  }

  /** Build a srcset from a list of [filter, width]. */
  srcset(originalPublicUrl: string, pairs: Array<[string, number]>): string {
    const rel = toUploadsRelativePath(originalPublicUrl);
    if (!rel) return '';
    return pairs.map(([f, w]) => `${buildDerivativeUrl(this.apiBase, this.strategy, f, rel)} ${w}w`).join(', ');
  }
}
